var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "data-testid": "contractual-reporting-page"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-header"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_vm._v("\n                Měsíc pro generování dávky "), _c('datepicker', {
    attrs: {
      "placeholder": "vybrat datum",
      "format": "dd.MM.yyyy",
      "language": "cs",
      "monday-first": true,
      "full-month-name": true,
      "name": "validFrom",
      "input-class": "datapickerInput",
      "data-testid": "contractual-reporting-month"
    },
    model: {
      value: (_vm.selectedDate),
      callback: function($$v) {
        _vm.selectedDate = $$v
      },
      expression: "selectedDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_vm._v("\n                Filtr. pojišťovny\n                "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.generateParams.filter_insurance_company_code),
      expression: "generateParams.filter_insurance_company_code"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Filtrované pojišťovny",
      "data-testid": "contractual-reporting-insurance-filter"
    },
    domProps: {
      "value": (_vm.generateParams.filter_insurance_company_code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.generateParams.filter_insurance_company_code = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_vm._v("\n                Vyřazené diagnózy\n                "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.generateParams.exclude_diagnosis_code),
      expression: "generateParams.exclude_diagnosis_code"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Vyřazené diagnózy",
      "data-testid": "contractual-reporting-excluded-diagnoses"
    },
    domProps: {
      "value": (_vm.generateParams.exclude_diagnosis_code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.generateParams.exclude_diagnosis_code = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_vm._v("\n                Filtr. diagnózy\n                "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.generateParams.filter_diagnosis_code),
      expression: "generateParams.filter_diagnosis_code"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Filtrované diagnózy",
      "data-testid": "contractual-reporting-diagnosis-filter"
    },
    domProps: {
      "value": (_vm.generateParams.filter_diagnosis_code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.generateParams.filter_diagnosis_code = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-check col-md-1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.generateParams.repair),
      expression: "generateParams.repair"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "value": "",
      "id": "repair",
      "data-testid": "contractual-reporting-repair"
    },
    domProps: {
      "checked": Array.isArray(_vm.generateParams.repair) ? _vm._i(_vm.generateParams.repair, "") > -1 : (_vm.generateParams.repair)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.generateParams.repair,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.generateParams.repair = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.generateParams.repair = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.generateParams.repair = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-check-label",
    attrs: {
      "for": "repair"
    }
  }, [_vm._v("\n                    Opravné\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "form-check col-md-1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.generateParams.dry),
      expression: "generateParams.dry"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "value": "",
      "id": "test",
      "data-testid": "contractual-reporting-dry-run"
    },
    domProps: {
      "checked": Array.isArray(_vm.generateParams.dry) ? _vm._i(_vm.generateParams.dry, "") > -1 : (_vm.generateParams.dry)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.generateParams.dry,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.generateParams.dry = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.generateParams.dry = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.generateParams.dry = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-check-label",
    attrs: {
      "for": "test"
    }
  }, [_vm._v("\n                    Test\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_vm._v("\n              Filtr. návštěvy dle id\n              "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.generateParams.filter_visit_id),
      expression: "generateParams.filter_visit_id"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Filtrované návštěvy",
      "data-testid": "contractual-reporting-visit-filter"
    },
    domProps: {
      "value": (_vm.generateParams.filter_visit_id)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.generateParams.filter_visit_id = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_vm._v("\n              Filtr. klientů dle id\n              "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.generateParams.filter_clients),
      expression: "generateParams.filter_clients"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Filtrovaní klienty",
      "data-testid": "contractual-reporting-client-filter"
    },
    domProps: {
      "value": (_vm.generateParams.filter_clients)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.generateParams.filter_clients = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row mt-4 justify-content-end"
  }, [_c('div', {
    staticClass: "col-md-1 text-right"
  }, [_c('button', {
    staticClass: "btn btn-secondary btn-sm",
    attrs: {
      "data-testid": "contractual-reporting-generate"
    },
    on: {
      "click": function($event) {
        _vm.generate()
      }
    }
  }, [_vm._v("Generovat")])])])]), _vm._v(" "), (_vm.generateContractualReportsPending) ? _c('div', {
    staticClass: "card-body"
  }, [_vm._m(1)]) : _vm._e(), _vm._v(" "), (_vm.generateContractualReports !== null) ? _c('div', {
    staticClass: "card-body",
    attrs: {
      "data-testid": "contractual-reporting-generated"
    }
  }, [_c('table', {
    staticClass: "table"
  }, [_vm._m(2), _vm._v(" "), _c('tbody', [_vm._l((_vm.generateContractualReports), function(cr, index) {
    return [_c('tr', {
      staticClass: "row m-0"
    }, [_c('td', {
      staticClass: "col-sm-1"
    }, [_vm._v("\n                " + _vm._s(cr.insurance_company_code) + "\n              ")]), _vm._v(" "), _c('td', {
      staticClass: "col-sm-1"
    }, [_vm._v("\n                " + _vm._s(cr.insurance_type_code) + "\n              ")]), _vm._v(" "), _c('td', {
      staticClass: "col-sm-1"
    }, [_vm._v("\n                " + _vm._s(cr.repair ? 'O' : 'P') + "\n              ")]), _vm._v(" "), _c('td', {
      staticClass: "col-sm-2"
    }, [_vm._v("\n                " + _vm._s(cr.points) + "\n              ")]), _vm._v(" "), _c('td', {
      staticClass: "col-sm-2"
    }, [_vm._v("\n                " + _vm._s(cr.price) + "\n              ")]), _vm._v(" "), _c('td', {
      staticClass: "col-sm-2"
    }, [_vm._v("\n                " + _vm._s(cr.number) + "\n              ")])])]
  })], 2)])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 text-right"
  }, [_c('button', {
    staticClass: "btn btn-secondary btn-sm",
    on: {
      "click": function($event) {
        _vm.getDoctorsDayTasks()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  })])])])]), _vm._v(" "), (_vm.listData.length > 0) ? _c('div', {
    staticClass: "card-body",
    attrs: {
      "data-testid": "contractual-reporting-list"
    }
  }, [(_vm.selectedIds.length > 0) ? _c('a', {
    staticClass: "btn btn-sm btn-success",
    attrs: {
      "href": _vm.hostname.hostname + 'contractual_reports/file_zip?ids=' + _vm.selectedIds.toString(),
      "target": "_blank",
      "role": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-archive"
  }), _vm._v(" Stáhnout zazipované")]) : _c('a', {
    staticClass: "btn btn-sm btn-success disabled",
    attrs: {
      "role": "button",
      "disabled": "disabled"
    }
  }, [_c('i', {
    staticClass: "fa fa-archive"
  }), _vm._v(" Stáhnout zazipované")]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_vm._m(4), _vm._v(" "), _c('tbody', [_vm._l((_vm.listData), function(cr, index) {
    return [_c('tr', {
      staticClass: "row m-0",
      attrs: {
        "data-testid": 'contractual-reporting-row-' + cr.id
      }
    }, [_c('td', {
      staticClass: "col-sm-1"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedIds),
        expression: "selectedIds"
      }],
      staticClass: "form-check-input",
      attrs: {
        "type": "checkbox",
        "data-testid": 'contractual-reporting-select-' + cr.id
      },
      domProps: {
        "value": cr.id,
        "checked": Array.isArray(_vm.selectedIds) ? _vm._i(_vm.selectedIds, cr.id) > -1 : (_vm.selectedIds)
      },
      on: {
        "__c": function($event) {
          var $$a = _vm.selectedIds,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = cr.id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.selectedIds = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.selectedIds = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.selectedIds = $$c
          }
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "col-sm-1",
      attrs: {
        "title": cr.insurance_company.name
      }
    }, [_vm._v("\n                        " + _vm._s(cr.insurance_company.code) + "\n                      ")]), _vm._v(" "), _c('td', {
      staticClass: "col-sm-1",
      attrs: {
        "title": cr.insurance_type.name
      }
    }, [_vm._v("\n                        " + _vm._s(cr.insurance_type.code) + "\n                      ")]), _vm._v(" "), _c('td', {
      staticClass: "col-sm-1",
      attrs: {
        "title": cr.repair ? 'Opravná' : 'Původní'
      }
    }, [_vm._v("\n                        " + _vm._s(cr.repair ? 'O' : 'P') + "\n                      ")]), _vm._v(" "), _c('td', {
      staticClass: "col-sm-2"
    }, [_vm._v("\n                        " + _vm._s(_vm.$moment(cr.created_at, 'DD.MM.YYYY H:mm').format('DD.MM.YYYY HH:mm')) + "\n                      ")]), _vm._v(" "), _c('td', {
      staticClass: "col-sm-2"
    }, [_vm._v("\n                        " + _vm._s(cr.points) + "\n                      ")]), _vm._v(" "), _c('td', {
      staticClass: "col-sm-2"
    }, [_vm._v("\n                        " + _vm._s(cr.price) + "\n                      ")]), _vm._v(" "), _c('td', {
      staticClass: "col-sm-1"
    }, [_vm._v("\n                        " + _vm._s(cr.number) + "\n                      ")]), _vm._v(" "), _c('td', {
      staticClass: "col-sm-1"
    }, [_c('a', {
      staticClass: "btn btn-sm btn-primary",
      attrs: {
        "target": "_blank",
        "role": "button",
        "href": _vm.hostname.hostname + 'contractual_reports/' + cr.id + '/file'
      }
    }, [_c('i', {
      staticClass: "fa fa-download"
    })]), _vm._v(" "), (!_vm.deleteContractualReportPending) ? _c('button', {
      staticClass: "btn btn-sm btn-danger",
      attrs: {
        "data-testid": 'contractual-reporting-delete-' + cr.id
      },
      on: {
        "click": function($event) {
          _vm.deleteContractualReport(cr.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash-o"
    })]) : _c('button', {
      staticClass: "btn btn-sm btn-danger disabled",
      attrs: {
        "disabled": "disabled"
      }
    }, [_c('i', {
      staticClass: "fa fa-trash-o"
    })])])])]
  })], 2)]), _vm._v(" "), _c('pagination-component', {
    attrs: {
      "list-pagination": _vm.listPagination
    },
    on: {
      "set-page": _vm.setPage
    }
  })], 1) : (_vm.listPending) ? _c('div', {
    staticClass: "card-body"
  }, [_vm._m(5)]) : _c('div', {
    staticClass: "card-body"
  }, [_vm._m(6)])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('b', [_vm._v("Generování dávek")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  })])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-3x fa-fw"
  }), _c('br'), _vm._v("\n          (generuji)\n        ")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "row m-0"
  }, [_c('th', {
    staticClass: "col-sm-1"
  }, [_vm._v("Pojišťovna")]), _vm._v(" "), _c('th', {
    staticClass: "col-sm-1"
  }, [_vm._v("Typ")]), _vm._v(" "), _c('th', {
    staticClass: "col-sm-1"
  }, [_vm._v("Charakter")]), _vm._v(" "), _c('th', {
    staticClass: "col-sm-2"
  }, [_vm._v("Počet bodů")]), _vm._v(" "), _c('th', {
    staticClass: "col-sm-2"
  }, [_vm._v("Cena")]), _vm._v(" "), _c('th', {
    staticClass: "col-sm-2"
  }, [_vm._v("Kód souboru")]), _vm._v(" "), _c('th', {
    staticClass: "col-sm-1"
  })])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6"
  }, [_c('b', [_vm._v("Přehled dříve vygenerovaných dávek")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "row m-0"
  }, [_c('th', {
    staticClass: "col-sm-1"
  }), _vm._v(" "), _c('th', {
    staticClass: "col-sm-1"
  }, [_vm._v("Pojišťovna")]), _vm._v(" "), _c('th', {
    staticClass: "col-sm-1"
  }, [_vm._v("Typ")]), _vm._v(" "), _c('th', {
    staticClass: "col-sm-1"
  }, [_vm._v("Charakter")]), _vm._v(" "), _c('th', {
    staticClass: "col-sm-2"
  }, [_vm._v("Vygenerováno")]), _vm._v(" "), _c('th', {
    staticClass: "col-sm-2"
  }, [_vm._v("Počet bodů")]), _vm._v(" "), _c('th', {
    staticClass: "col-sm-2"
  }, [_vm._v("Cena")]), _vm._v(" "), _c('th', {
    staticClass: "col-sm-1"
  }, [_vm._v("Kód souboru")]), _vm._v(" "), _c('th', {
    staticClass: "col-sm-1"
  })])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-3x fa-fw"
  }), _c('br'), _vm._v("\n                  (načítám)\n          ")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-frown-o fa-3x"
  }), _c('br'), _vm._v("\n              (nebyl nalezen žádný výsledek dle požadavků)\n          ")])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28cebb47","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/ContractualReporting/components/ContractualReporting.vue
// module id = 744
// module chunks = 0